export enum CrosswordTilesEnum {
  EmptyField = 'empty',
  OriginalSolution = 'original',
  InputField = '1',
  DefinitionField = '0',
  HiddenField = '2', // no boarders drawn
  DividerField = '3', // black field
}
